import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./floor-create-import-review.module.scss";
import PinnedList from "../pinned-list";
import PinnedListHeader from "../pinned-list-header";
import VelavuIconButton from "../../../../elements/velavu-icon-button";
import IconClose from "../../../../dynamicicons/icon-close";
import VelavuButton from "../../../../elements/velavu-button";
import UserImageData, {
	useUserImageDataURL,
} from "../../../../data/user-image-data";
import DocumentUploadPreview from "../../../../elements/document-upload-preview";
import whitelabel from "../../../../whitelabel";

export interface FloorCreateImportReviewProps {
	image: UserImageData;
	onNext?: () => void;
	onBack?: () => void;
	onClose?: () => void;
}

export function FloorCreateImportReview(props: FloorCreateImportReviewProps) {
	const { t } = useTranslation();
	const imageURL = useUserImageDataURL(props.image.renderable);

	return (
		<PinnedList>
			<PinnedListHeader
				label={t("dashboard.floor_create.upload_header")}
				onClose={props.onClose}
			/>

			<div className={styles.content}>
				<DocumentUploadPreview
					src={imageURL}
					label={props.image.name}
					action={
						<VelavuIconButton onClick={props.onBack}>
							<IconClose
								color={whitelabel.palette.secondary500}
							/>
						</VelavuIconButton>
					}
				/>

				<VelavuButton
					label={t("common.place_on_map")}
					onClick={props.onNext}
					fullWidth
				/>
			</div>
		</PinnedList>
	);
}
